// import {
//   Button,
//   Container,
//   Grid,
//   Paper,
//   TextField,
//   Typography,
// } from "@material-ui/core";
// import Logo from "../../Assets/logo.png";

// import axios from "axios";
// import { Link } from "react-router-dom";

// import React, { Component } from "react";
// import Constants from "../Variables/Constants";

// export default class Login extends Component {
//   state = {
//     error: false,
//     mobile_no: "",
//     password: "",
//   };

//   login = (e) => {
//     this.setState({
//       loading: true,
//     });
//     e.preventDefault();
//     let loginLoad = {
//       mobile_no: this.state.mobile_no,
//       password: this.state.password,
//     };
//     axios
//       .post(Constants.postUrls.login, loginLoad)
//       .then((resp) => {

//         localStorage.setItem("accessToken", resp.data.data.token);

//         window.location.href = "/dashboard";

//         this.setState({
//           notification: true,
//           loading: false,
//         });
//       })
//       .catch((err) => {
//         if (err) {
//           console.log(err);
//           this.setState({
//             loading: false,
//             message: "Invalid Credentials",
//             error: true,
//           });
//           setTimeout(() => {
//             this.setState({
//               error: false,
//             });
//           }, 3000);
//         }
//       });
//   };

//   handleInput = (e) => {
//     this.setState({
//       [e.target.name]: e.target.value,
//     });
//   };
//   render() {
//     return (
//       <div className="loginWrapper">
//         <div
//           style={{
//             height: "100%",
//             backgroundColor: "#111",
//             opacity: "0.8",
//           }}
//         >
//           <img
//             src={Logo}
//             style={{
//               margin: "50px",
//               height: "160px",
//               width: "190px",
//             }}
//           />
//         </div>
//         <Container
//           maxWidth="md"
//           style={{
//             position: "absolute",
//             top: "60%",
//             left: "50%",
//             transform: "translate(-50%,-50%)",
//           }}
//         >
//           <Grid container>
//             <Grid
//               item
//               sm={6}
//               style={{
//                 position: "relative",
//                 height: "80vh",
//                 marginTop: "-100px",
//               }}
//             >
//               <Paper
//                 className="loginCard"
//                 elevation={15}
//                 style={{ height: "50vh", opacity: "1" }}
//               >
//                 <Typography
//                   variant="h4"
//                   style={{ fontWeight: "bold" }}
//                   component="h1"
//                 >
//                   Log in
//                 </Typography>
//                 <Typography
//                   variant="body2"
//                   component="h1"
//                   gutterBottom
//                   style={{ fontWeight: "bold", marginBottom: "40px" }}
//                   color="textSecondary"
//                 >
//                   Continue to Admin dashboard
//                 </Typography>
//                 <form
//                   className="loginFormWrapper"
//                   style={{
//                     height: "100%",
//                     display: "flex",
//                     flexDirection: "column",
//                     justifyContent: "center",
//                     gap: "20px",
//                   }}
//                   onSubmit={this.login}
//                 >
//                   <TextField
//                     color="success"
//                     label=""
//                     placeholder="Registered Mobile Number"
//                     variant="outlined"
//                     fullWidth
//                     name="mobile_no"
//                     onChange={this.handleInput}
//                   />
//                   <TextField
//                     placeholder="Password"
//                     variant="outlined"
//                     fullWidth
//                     name="password"
//                     type="password"
//                     onChange={this.handleInput}
//                   />

//                   <Button
//                     style={{
//                       alignSelf: "flex-start",
//                       backgroundColor: "#EEC17F",
//                       color: "#fff",
//                       fontWeight: "bold",
//                       width: "160px",
//                       borderRadius: "200px",
//                     }}
//                     variant="contained"
//                     size="large"
//                     type="submit"
//                   >
//                     {this.state.loading ? (
//                       "Logging In..."
//                     ) : this.state.error ? (
//                       <span style={{ color: "#BD0600" }}>
//                         Incorrect Credentials!!!
//                       </span>
//                     ) : (
//                       " Log In"
//                     )}
//                   </Button>
//                 </form>
//               </Paper>
//             </Grid>
//           </Grid>
//         </Container>
//       </div>
//     );
//   }
// }


import React, { useState } from "react";
import {
  Button,
  Container,
  Grid,
  Paper,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import axios from "axios";
import Logo from "../../Assets/logo.png";
import Constants from "../Variables/Constants";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import bgImg from "../../Assets/login_bg.png";

// Validation schema
const loginSchema = yup.object().shape({
  mobile_no: yup
    .string()
    .required("Mobile number is required")
    .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits"),
  password: yup
    .string()
    .required("Password is required")
    .min(6, "Password must be at least 6 characters"),
});

const Login = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginSchema),
  });

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await axios.post(Constants.postUrls.login, data);
      localStorage.setItem("accessToken", response.data.data.token);
      toast.success("Login successful!");
      if (response.data.data.role === "design_admin") {
        window.location.href = "/design";
      } else if (response.data.data.role === "admin") {
        window.location.href = "/dashboard";
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error(error.response?.data?.message || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    // <div
    //   style={{
    //     width: "100vw",
    //     height: "100vh",
    //     backgroundImage: `url(${bgImg})`,
    //     backgroundSize: "cover",
    //   }}
    // >
    //   <div
    //     style={{
    //       height: "100%",
    //       backgroundColor: "#111",
    //       opacity: "0.8",
    //     }}
    //   >
    //     <div
    //       style={{
    //         minHeight: "100vh",
    //         display: "flex",
    //         flexDirection: isMobile ? "column" : "row",
    //         alignItems: isMobile ? "center" : "stretch",
    //       }}
    //     >

    //       {/* Logo Section - Simplified */}
    //       <div
    //         style={{
    //           display: "flex",
    //           justifyContent: "center",
    //           alignItems: "center",
    //           padding: isMobile ? "2rem 1rem" : "3rem",
    //           width: isMobile ? "100%" : "auto",
    //         }}
    //       >
    //         <img
    //           src={Logo}
    //           alt="Company Logo"
    //           style={{
    //             height: isMobile ? "80px" : "120px",
    //             width: "auto",
    //             objectFit: "contain",
    //           }}
    //         />
    //       </div>

    //       {/* Login Form Section - Optimized for small screens */}
    //       <Container
    //         maxWidth="sm"
    //         style={{
    //           padding: isMobile ? "1rem" : "2rem",
    //           margin: isMobile ? "0" : "auto",
    //           flex: 1,
    //           display: "flex",
    //           alignItems: "center",

    //         }}
    //       >
    //         <Grid container justifyContent="center">
    //           <Grid item xs={12}>
    //             <Paper
    //               elevation={isMobile ? 2 : 8}
    //               style={{
    //                 padding: isMobile ? "1.5rem" : "2.5rem",
    //                 borderRadius: "12px",
    //                 width: "100%",
    //               }}
    //             >
    //               <Typography
    //                 variant={isMobile ? "h5" : "h4"}
    //                 style={{ fontWeight: "bold", marginBottom: "0.5rem" }}
    //                 component="h1"
    //               >
    //                 Log in
    //               </Typography>

    <div
      style={{
        width: "100vw",
        height: "100vh",
        backgroundImage: `url(${bgImg})`,
        backgroundSize: "cover",
      }}
    >
      <div
        style={{
          height: "100%",
          backgroundColor: "rgba(17, 17, 17, 0.8)", // Using rgba instead of opacity
        }}
      >
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: isMobile ? "center" : "stretch",
          }}
        >
          {/* Logo Section - Simplified */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: isMobile ? "2rem 1rem" : "3rem",
              width: isMobile ? "100%" : "auto",
            }}
          >
            <img
              src={Logo}
              alt="Company Logo"
              style={{
                height: isMobile ? "80px" : "200px",
                position: "relative",
                bottom: isMobile ? "0" : 250,
                width: "auto",
                objectFit: "contain",
              }}
            />
          </div>

          {/* Login Form Section - Optimized for small screens */}
          <Container
            maxWidth="sm"
            style={{
              padding: isMobile ? "4px" : "2rem",
              margin: isMobile ? "0" : "auto",
              flex: 1,
              display: "flex",
              alignItems: "center",
              maxWidth: isMobile ? "500px" : "600px",
            }}
          >
            <Grid container justifyContent="center">
              <Grid item xs={12}>
                <Paper
                  elevation={isMobile ? 2 : 8}
                  style={{
                    padding: isMobile ? "1.5rem 0.8rem" : "2.5rem",
                    borderRadius: "12px",
                    width: "100%",
                    backgroundColor: "#fff",
                   // Explicit white background for the form
                  }}
                >
                  <Typography
                    variant={isMobile ? "h5" : "h4"}
                    style={{ fontWeight: "bold", marginBottom: "0.5rem", color:"#000" }}
                    component="h1"
                  >
                    Log in
                  </Typography>

                  <Typography
                    variant="body2"
                    component="p"
                    gutterBottom
                    style={{
                      fontWeight: "bold",
                      marginBottom: "2rem",
                      color: theme.palette.text.secondary,
                    }}
                  >
                    Continue to Admin dashboard
                  </Typography>

                  <form
                    onSubmit={handleSubmit(onSubmit)}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "1.25rem",
                    }}
                  >
                    <TextField
                      label={isMobile ? "Mobile Number" : "Registered Mobile Number"}
                      variant="standard"
                      fullWidth
                      size={isMobile ? "small" : "medium"}
                      {...register("mobile_no")}
                      error={!!errors.mobile_no}
                      helperText={errors.mobile_no?.message}
                
                    />

                    <TextField
                      label="Password"
                      variant="standard"
                      fullWidth
                      type="password"
                      size={isMobile ? "small" : "medium"}
                      {...register("password")}
                      error={!!errors.password}
                      helperText={errors.password?.message}
                      InputLabelProps={{ shrink: true }}
                    />

                    <Button
                      style={{
                        backgroundColor: "#EEC17F",
                        color: "#fff",
                        fontWeight: "bold",
                        width: isMobile ? "100px" : "160px",
                        borderRadius: "200px",
                        marginTop: "0.5rem",
                        padding: isMobile ? "8px 16px" : "10px 24px",
                      }}
                      variant="contained"
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? "Logging In..." : "Log In"}
                    </Button>

                    {/* {!isMobile && (
                      <Typography
                        variant="body2"
                        style={{ marginTop: "1rem", textAlign: "center" }}
                      >
                        Don't have an account?{" "}
                        <Link
                          to="/register"
                          style={{ color: theme.palette.primary.main }}
                        >
                          Sign up
                        </Link>
                      </Typography>
                    )} */}
                  </form>
                </Paper >
              </Grid >
            </Grid >
          </Container >
        </div >
      </div >
    </div >
  );
};

export default Login;